const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i
const HEX_ID = /^[0-9a-f]{16,}$/i
const DIGITS = /^\d+$/

/** Turns a path or URL into a route-style template: ids become `:id`, query and hash are dropped. */
export function templatePath(input: string): string {
  let path = input
  const scheme = path.indexOf('://')
  if (scheme !== -1) {
    const afterHost = path.indexOf('/', scheme + 3)
    path = afterHost === -1 ? '/' : path.slice(afterHost)
  }
  path = path.split('#')[0].split('?')[0]
  if (path === '') return '/'
  const segments = path.split('/').map((segment) => {
    if (UUID.test(segment) || HEX_ID.test(segment) || DIGITS.test(segment)) return ':id'
    return segment
  })
  return segments.join('/') || '/'
}
